import React, { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { Typography, Button, Stack, useMediaQuery, useTheme, SvgIcon } from "@mui/material";
import TextsmsIcon from '@mui/icons-material/Textsms';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import { useNavigate } from "react-router-dom";
import { ReactComponent as CasesSvg } from '../../assets/icons/health_metrics.svg';
import { reset as userReset } from "../../redux/userSlice";
import { reset as insuranceReset } from "../../redux/insuranceSlice";
import { reset as stripeReset } from "../../redux/stripeSlice";
import Question from '../../components/Question';
import InfoCard from "../../components/InfoCard";
import { handleContactCareTeam } from "../../lib/utils";

const HealthMetrics = React.forwardRef(function HealthMetricsIcon(props, ref) {
    return (
        <SvgIcon
            component={CasesSvg}
            inheritViewBox
            ref={ref}
            {...props}
        />
    );
});

export default function CaseThankYou(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    useEffect(() => {
        dispatch(userReset());
        dispatch(insuranceReset());
        dispatch(stripeReset());
    }, [dispatch]);

    return (
        <Question
            noBack={true}
            backgroundColor="#82B1FF33"
            componentHeight="100vh"
            title={`Thank You!`}
            input={
                <>
                    <Typography variant="body1" mt={1} mb={2}>
                        Your information has been securely submitted.
                    </Typography>

                    <Typography variant="h6" fontWeight={400} mt={2} mb={1}>
                        What to Expect Next
                    </Typography>

                    <InfoCard
                        icon={MedicalInformationIcon}
                        title="Dermatologist Review"
                        description="A board-certified dermatologist will personally review your information and photos to develop your customized treatment plan."
                    />

                    <InfoCard
                        icon={VideoCallIcon}
                        title="Video Visit"
                        description="Next, you'll have a dedicated 15-minute video call with one of our expert nurse practitioners. During this visit, they will review your personalized treatment plan in detail and answer any questions you have."
                    />

                    <Stack
                        direction="column"
                        spacing={2}
                        mt={2}
                        sx={{
                            width: "100%",
                            alignItems: "center",
                        }}
                    >
                        <Button
                            fullWidth
                            variant="outlined"
                            startIcon={<TextsmsIcon />}
                            onClick={handleContactCareTeam}
                            sx={{
                                width: isDesktop ? "50%" : "100%",
                                borderColor: "piction.highlight",
                                backgroundColor: "piction.highlight",
                                color: "white",
                                borderRadius: "20px",
                                fontFamily: "Inter, sans-serif",
                                fontWeight: 600,
                                px: 2.5,
                                "&:hover, &:active, &:focus": {
                                    backgroundColor: "piction.highlight",
                                    borderColor: "piction.highlight",
                                    color: "white",
                                    boxShadow: "none"
                                }
                            }}
                        >
                            Text Us
                        </Button>

                        <Button
                            fullWidth
                            variant="outlined"
                            startIcon={<HealthMetrics sx={{ color: 'white' }} />}
                            onClick={() => navigate("/case-list", { state: { portal: true } })}
                            sx={{
                                width: isDesktop ? "50%" : "100%",
                                borderColor: "piction.highlight",
                                backgroundColor: "piction.highlight",
                                color: "white",
                                borderRadius: "20px",
                                fontFamily: "Inter, sans-serif",
                                fontWeight: 600,
                                px: 2.5,
                                "&:hover, &:active, &:focus": {
                                    backgroundColor: "piction.highlight",
                                    borderColor: "piction.highlight",
                                    color: "white",
                                    boxShadow: "none"
                                }
                            }}
                        >
                            Visit Patient Portal
                        </Button>
                    </Stack>
                </>
            }
            {...props}
        />
    );
}
